export default __webpack_public_path__ + "static/media/20-min.5a808f6f.jpg";